import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class TaxReportService {

  public customer: CustomerModel;
  constructor(
    public userSessionService: UserSessionService,
    public webservicesService: WebservicesService,
    private config: ConfigService,
  ) {
    this.userSessionService.getCustomer().subscribe(customer => {
      this.customer = customer;
    });
  }

  public callPostTaxConfirm(report) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.sessionToken,
      id: report.id
    }
    return this.webservicesService.post('cashier/tax-report-confirm', obj);
  }

  public callPostSendTaxReport(report) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.sessionToken,
      id: report.id,
      clientapp: this.config.getClientApp()
    }
    return this.webservicesService.post('cashier/send-tax-report', obj);
  }

  public getTaxReportUrl(report) {
    let url = '';
    let webServiceUrl = this.config.getEnv().webservices_url;
    let params = new URLSearchParams();
    params.set('customer_id', (this.customer.customerId).toString());
    params.set('session_token', this.userSessionService.sessionToken);
    params.set('id', report.id);
    url = `${webServiceUrl}/cashier/tax-report-generate?` + params.toString();
    return url;
  }

  public callGetTaxReport(date_from: string, date_to: string, page: number = 1, numRecords: number = 25) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.sessionToken,
      date_from: date_from,
      date_to: date_to,
      pageno: page,
      invalidate_cache: 1
      //num: numRecords
    }

    return this.webservicesService.get('cashier/get-tax-report', obj);
  }

  //need to move this api to game service folder
  public callCasinoGameDetails(id: string, host: string, connect: string, disconnect: string, page: number = 1) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.sessionToken,
      id: id,
      host: host,
      connect: connect,
      disconnect: disconnect,
      page: page
    }

    return this.webservicesService.get('games/casino-game-hands-history', obj);
  }
}
